

































import { Component, Vue } from 'vue-property-decorator';
import { ICourse, ICartCourse, ICalendarSession } from '@/interfaces';
import { AjaxHelper } from '@/AjaxHelper';
import { CartGetters } from '@/Getters';

import Description from '@/components/Description.vue';
import Btn from '@/components/Btn.vue';
import List from '@/components/List.vue';
import ListItem from '@/components/ListItem.vue';

@Component({
  name: 'course-page',
  components: { Description, Btn, List, ListItem },
  beforeRouteEnter: async (to, from, next) => {
    const course = await AjaxHelper.get<ICourse>(`/course/${to.params.id}`);
    const sessions = (await AjaxHelper.get<any>(`/sessionmanagement/${course.moodleId}`)).sessions;

    next(vm => {
      (vm as any).course = course;
      (vm as any).sessions = sessions;
    });
  }
})
export default class CourseComponent extends Vue {
  public course: ICourse | null = null;
  public addingToCart = false;
  public sessions: ICalendarSession[] = [];

  public get exists(): boolean { return this.$store.getters[CartGetters.getCourses].findIndex((x: ICartCourse) => x.moodleId === this.course?.moodleId) > -1; }

  public async addToCart() {
    if (this.course !== null) {
      try {
        this.addingToCart = true;

        await this.$store.dispatch('addCourseToCart', this.course);
        this.$alert.success('Added to Cart', `${this.course.fullName} has been added to the cart`);
      } catch {
        this.$alert.danger('Error Occured', 'Course was not added to the cart');
      } finally {
        this.addingToCart = false;
      }
    }
  }
}
